import { render, staticRenderFns } from "./helpCenter.vue?vue&type=template&id=33672382&scoped=true"
import script from "./helpCenter.vue?vue&type=script&lang=js"
export * from "./helpCenter.vue?vue&type=script&lang=js"
import style0 from "./helpCenter.vue?vue&type=style&index=0&id=33672382&prod&lang=css"
import style1 from "./helpCenter.vue?vue&type=style&index=1&id=33672382&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33672382",
  null
  
)

export default component.exports